export default {
	tenantId: "temp_pre_prod",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "covergo-apse1-preprod",
	},
}
